import { FunctionComponent, memo } from "react";
import { IProps } from "./search-type-tooltip-content.types";
import "./search-type-tooltip-content.scss";

/**
 * The tooltip content for the search type field.
 */
const SearchTypeTooltipContent: FunctionComponent<IProps> = () => (
    <div className="search-type-tooltip-content">
        <div className="search-type-tooltip-content__section">
            <h5>Similar Search</h5>
            <p>The similar search will find sentences that are similar to the phrase you input.</p>
            <p>
                For example, inputting a phrase like “I keep getting a blank page” will find other sentences that mean
                similar things like “The page doesn't load”.
            </p>
            <p>
                Typically you will need to add a number of phrases, to cover a topic, and the best examples are ones
                that come from real life messages.
            </p>
        </div>

        <div className="search-type-tooltip-content__section">
            <h5>Exact Search</h5>
            <p>
                The exact search works by finding exact matches to the words or phrases you provide. So inputting
                'Money' will tag any messages that have the word 'Money', but will not tag a message that has a similar
                word (like 'Cash').
            </p>
            <div>
                <p>Some sample searches are:</p>
                <ul>
                    <li>“Payment”: Tag messages that contain this word.</li>
                    <li>“Payment” OR “Money”: Tag messages that contain either of these words.</li>
                    <li>“Payment” AND “Money”: Tag messages that contain both of these words</li>
                    <li>“I have a payment error”: Tag messages that contain this exact phrase.</li>
                    <li>
                        “(”7 days”) AND NOT (”7 days a week”)”: Tag messages that contain “7 days” but don't contain “7
                        days a week”.
                    </li>
                </ul>
            </div>
        </div>
    </div>
);

export default memo(SearchTypeTooltipContent);
